var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialNetworkPinterest18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2 1.5C5.154 1.5 3 4.134 3 7.007c0 1.332.733 2.994 1.906 3.52.178.082.275.048.315-.12.035-.128.19-.742.264-1.032a.27.27 0 00-.063-.26c-.39-.458-.698-1.291-.698-2.073 0-2.004 1.568-3.95 4.237-3.95 2.308 0 3.922 1.523 3.922 3.701 0 2.461-1.282 4.164-2.948 4.164-.923 0-1.61-.735-1.392-1.644.264-1.083.78-2.248.78-3.029 0-.7-.39-1.28-1.186-1.28-.939 0-1.7.945-1.7 2.212 0 .806.28 1.35.28 1.35l-1.1 4.521c-.293 1.205.039 3.156.068 3.324.017.092.12.122.177.046.091-.122 1.214-1.749 1.528-2.925l.585-2.165c.31.567 1.202 1.042 2.153 1.042C12.956 12.41 15 9.884 15 6.751 14.99 3.747 12.459 1.5 9.2 1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialNetworkPinterest18);
export default __webpack_public_path__ + "7238d20474eca0ca334111b0b75b3bc1.svg";
export { ForwardRef as ReactComponent };